module.exports = __webpack_public_path__ + "static/img/banner@2x.8b00f5dd.png";